<div class="container" [ngClass]="{'ionic': useIonic }">
    <div class="lists">
        <div class="trucking-shipments">
            <shared-trucking-shipments [selectedRouteExpand]="selectedRouteExpand"></shared-trucking-shipments>
        </div>
        <div class="trucking-routes">
            <shared-trucking-routes (clickItem)="onSelectedRoute($event)"
                [selectedRoute]="selectedRouteExpand"></shared-trucking-routes>
        </div>
    </div>
    <shared-trucking-route-panel [selectedRouteExpand]="selectedRouteExpand" (clickBack)="onClickBack($event)"
        (refreshRoute)="onRefreshRoute($event)">
    </shared-trucking-route-panel>
</div>